import { RefreshCw, Link2 } from 'lucide-react';
import { OpenAIAssistant, APIConfig } from './MessageRenderer';

interface Props {
  apiConfigs: APIConfig[];
  selectedApiConfig: APIConfig | null;
  openAIAssistants: OpenAIAssistant[];
  activeAssistant: OpenAIAssistant | null;
  isConnecting: boolean;
  isLoadingAssistants: boolean;
  isConnectingAssistant: boolean;
  onApiConfigSelect: (id: string) => void;
  onConnect: (id: string) => void;
  onLoadAssistants: () => void;
  onAssistantSelect: (id: string) => void;
  onConnectAssistant: (assistant: OpenAIAssistant) => void;
}

export function ChatSetupPanel({
  apiConfigs,
  selectedApiConfig,
  openAIAssistants,
  activeAssistant,
  isConnecting,
  isLoadingAssistants,
  isConnectingAssistant,
  onApiConfigSelect,
  onConnect,
  onLoadAssistants,
  onAssistantSelect,
  onConnectAssistant
}: Props) {
  return (
    <div className="space-y-3">
      <div className="flex items-center space-x-2">
        <select
          value={selectedApiConfig?.id || ''}
          onChange={(e) => onApiConfigSelect(e.target.value)}
          className="flex-1 px-3 py-2 bg-white border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          disabled={isConnecting || isLoadingAssistants}
        >
          <option value="">Seleccionar API</option>
          {apiConfigs.map((config) => (
            <option key={config.id} value={config.id}>
              {config.nombre} ({config.entorno})
            </option>
          ))}
        </select>
        <button
          onClick={() => selectedApiConfig && onConnect(selectedApiConfig.id)}
          disabled={!selectedApiConfig || isConnecting}
          className="px-3 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:opacity-50 flex items-center space-x-2"
        >
          <RefreshCw className={`w-4 h-4 ${isConnecting ? 'animate-spin' : ''}`} />
          <span>Conectar</span>
        </button>
      </div>

      <div className="flex items-center space-x-2">
        <select
          name="assistant-select"
          value={activeAssistant?.id || ''}
          onChange={(e) => onAssistantSelect(e.target.value)}
          className="flex-1 px-3 py-2 bg-white border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          disabled={isConnecting || isLoadingAssistants || openAIAssistants.length === 0}
        >
          <option value="">Seleccionar asistente</option>
          {openAIAssistants.map((assistant) => (
            <option key={assistant.id} value={assistant.id}>
              {assistant.name} ({assistant.model})
            </option>
          ))}
        </select>
        <button
          onClick={onLoadAssistants}
          disabled={!selectedApiConfig || isConnecting || isLoadingAssistants}
          className="px-3 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:opacity-50 flex items-center space-x-2"
        >
          <RefreshCw className={`w-4 h-4 ${isLoadingAssistants ? 'animate-spin' : ''}`} />
          <span>Cargar</span>
        </button>
      </div>

      <div className="flex justify-center">
        <button
          onClick={() => activeAssistant && onConnectAssistant(activeAssistant)}
          disabled={!activeAssistant || isConnectingAssistant}
          className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 disabled:opacity-50 flex items-center space-x-2"
        >
          <Link2 className={`w-4 h-4 ${isConnectingAssistant ? 'animate-spin' : ''}`} />
          <span>Conectar Asistente</span>
        </button>
      </div>
    </div>
  );
}